/**
 * Order Service 
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { ErrorResponse } from '../model/errorResponse';
// @ts-ignore
import { PageInfoWarehousingNotice } from '../model/pageInfoWarehousingNotice';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class WarehousingNoticeControllerService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Get paginated list of warehouse notices
     * @param code Notice code
     * @param innerOrderNo Inner order number
     * @param innerRefundNo Inner refund number
     * @param outerOrderNo Platform order number
     * @param outerRefundNo Third-party refund/return number
     * @param status Status
     * @param fromDate From created date (yyyy-MM-dd)
     * @param toDate To created date (yyyy-MM-dd)
     * @param page 
     * @param size 
     * @param sortBy 
     * @param ascending 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public noticePage(code?: string, innerOrderNo?: string, innerRefundNo?: string, outerOrderNo?: string, outerRefundNo?: string, status?: number, fromDate?: string, toDate?: string, page?: number, size?: number, sortBy?: string, ascending?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*', context?: HttpContext, transferCache?: boolean}): Observable<PageInfoWarehousingNotice>;
    public noticePage(code?: string, innerOrderNo?: string, innerRefundNo?: string, outerOrderNo?: string, outerRefundNo?: string, status?: number, fromDate?: string, toDate?: string, page?: number, size?: number, sortBy?: string, ascending?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PageInfoWarehousingNotice>>;
    public noticePage(code?: string, innerOrderNo?: string, innerRefundNo?: string, outerOrderNo?: string, outerRefundNo?: string, status?: number, fromDate?: string, toDate?: string, page?: number, size?: number, sortBy?: string, ascending?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PageInfoWarehousingNotice>>;
    public noticePage(code?: string, innerOrderNo?: string, innerRefundNo?: string, outerOrderNo?: string, outerRefundNo?: string, status?: number, fromDate?: string, toDate?: string, page?: number, size?: number, sortBy?: string, ascending?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: '*/*', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>code, 'code');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>innerOrderNo, 'innerOrderNo');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>innerRefundNo, 'innerRefundNo');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>outerOrderNo, 'outerOrderNo');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>outerRefundNo, 'outerRefundNo');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>status, 'status');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>fromDate, 'fromDate');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>toDate, 'toDate');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>page, 'page');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>size, 'size');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortBy, 'sortBy');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>ascending, 'ascending');

        let localVarHeaders = this.defaultHeaders;

        // authentication (BearerAuthentication) required
        localVarHeaders = this.configuration.addCredentialToHeaders('BearerAuthentication', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            '*/*'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/warehousing-notice`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PageInfoWarehousingNotice>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
